/**
 * PrimeNG Theme Configuration
 * 
 * Configure PrimeNG theming for the platform
 * @see https://primeng.org/installation
 * @see https://primeng.org/theming/styled
 */

import { definePreset } from '@primeuix/themes';
import { convertThemeConfigToPreset } from './theme.utils';
import type { PlatformConfig } from '@platform/config';
import Zara from './default.theme';

/**
 * Creates a platform theme preset based on default theme and platform configuration
 * 
 * @param platformConfig - Platform configuration containing theme settings
 * @returns PrimeNG theme preset
 */
export function createPlatformTheme(platformConfig: PlatformConfig) {
  const themeConfig = platformConfig.theme;
  const brandingConfig = platformConfig.branding;

  // Convert platform theme config to PrimeNG preset format
  const presetOptions = convertThemeConfigToPreset(themeConfig, brandingConfig);

  // If no customizations, return default theme as-is
  if (!presetOptions.semantic || Object.keys(presetOptions.semantic).length === 0) {
    return defaultPlatformTheme;
  }

  // Create customized preset
  // Cast to any to work around PrimeNG's internal Preset type
  // The structure matches what definePreset expects
  return definePreset(defaultPlatformTheme, presetOptions as any);
}

/**
 * Default platform theme (used when config is not available)
 */
export const defaultPlatformTheme = Zara;

